import { SESClient, SendEmailCommand } from "@aws-sdk/client-ses";
import { REGION } from "~/_server/constants";
import { renderEmail } from "~/_email/render";

//import "../_email/templates.manifest";

//const TEMPLATE_PATH = "./templates";

import ApplicationVerified from "~/_email/templates/ApplicationVerified";
import ApprovedBodyRequest from "~/_email/templates/ApprovedBodyRequest";
import ApprovedBodySubmitted from "~/_email/templates/ApprovedBodySubmitted";
import CertifierRequiringVerification from "~/_email/templates/CertifierRequiringVerification";
import CertifyDesigns from "~/_email/templates/CertifyDesigns";
import CompliancePassed from "~/_email/templates/CompliancePassed";
// import EpcChargesDue from "~/_email/templates/EpcChargesDue";
import ExamsPassed from "~/_email/templates/ExamsPassed";
import Invoice from "~/_email/templates/Invoice";
import ResetPassword from "~/_email/templates/ResetPassword";
import SchemeUpdate from "~/_email/templates/SchemeUpdate";
import SubscriptionComplete from "~/_email/templates/SubscriptionComplete";
import SubscriptionLapsed from "~/_email/templates/SubscriptionLapsed";
import SubscriptionRenewed from "~/_email/templates/SubscriptionRenewed";
import SubscriptionRenewRequired from "~/_email/templates/SubscriptionRenewRequired";
import Welcome from "~/_email/templates/Welcome";

export const sendEmail = async ({
	templateName,
	props,
	to,
	subject,
	from = "no-reply@example.com",
}: {
	templateName: string;
	props: any;
	to: string;
	from?: string;
}) => {
	"use server";

	try {
		const emailArgs = getEmailArgs(templateName);
		if (emailArgs) {
			const { html, text } = await renderEmail(emailArgs.template, props);

			const ses = new SESClient({ region: REGION });

			await ses.send(
				new SendEmailCommand({
					Source: from,
					Destination: { ToAddresses: [to] },
					Message: {
						Subject: { Data: props.subject ?? emailArgs.subject },
						Body: {
							Html: { Data: html },
							Text: { Data: text },
						},
					},
				})
			);
		} else {
			console.error("invalid email template", templateName);
		}
	} catch (err) {
		console.error("sendEmail failed", err);
		throw err;
	}
};

const getEmailArgs = (template: string) => {
	let emailArgs;
	switch (template) {
		case "application-verified":
			emailArgs = {
				subject: "Your application has been verified",
				template: ApplicationVerified,
			};
			break;
		case "approved-body-request":
			emailArgs = { subject: "Approved Body Request", template: ApprovedBodyRequest };
			break;
		case "approved-body-submitted":
			emailArgs = { subject: "Approved Body Submitted", template: ApprovedBodySubmitted };
			break;
		case "certifier-requiring-verification":
			emailArgs = {
				subject: "Certifier Requiring Verification",
				template: CertifierRequiringVerification,
			};
			break;
		case "certify-designs":
			emailArgs = { subject: "You Can Now Certify Designs", template: CertifyDesigns };
			break;
		case "compliance-passed":
			emailArgs = { subject: "Competency Tests Passed", template: CompliancePassed };
			break;
		// case "epc-charges-due":
		// 	emailTemplate = EpcChargesDue;
		// 	break;
		case "exams-passed":
			emailArgs = {
				subject: "Congratulations, you have passed the On-line Competency Tests",
				template: ExamsPassed,
			};
			break;
		case "invoice":
			emailArgs = { subject: "Invoice", template: Invoice };
			break;
		case "reset-password":
			emailArgs = { subject: "Reset Password", template: ResetPassword };
			break;
		case "scheme-update":
			emailArgs = { subject: "RIAS Regs Scheme Update", template: SchemeUpdate };
			break;
		case "subscription-complete":
			emailArgs = {
				subject: "RIAS Certification Subscription Complete",
				template: SubscriptionComplete,
			};
			break;
		case "subscription-lapsed":
			emailArgs = { subject: "Subscription Lapsed", template: SubscriptionLapsed };
			break;
		case "subscription-renewed":
			emailArgs = { subject: "Subscription Renewed", template: SubscriptionRenewed };
			break;
		case "subscription-renew-required":
			emailArgs = {
				subject: "Subscription Renewal Required",
				template: SubscriptionRenewRequired,
			};
			break;
		case "welcome":
			emailArgs = { subject: "Welcome", template: Welcome };
			break;
		default:
			break;
	}
	return emailArgs;
};
